import React from "react";
import { MdArrowBack } from "react-icons/md";

interface ResultHeaderProps {
  questionnaireName: string;
  patientName: string;
  onBack: () => void;
}

const ResultHeader: React.FC<ResultHeaderProps> = ({ questionnaireName, patientName, onBack }) => {
  return (
    <div className="mb-6 flex items-center">
      <button
        onClick={onBack}
        className="mr-4 flex items-center justify-center rounded-lg p-2 text-navy-700 transition-all hover:bg-gray-100 dark:text-white dark:hover:bg-navy-700"
      >
        <MdArrowBack className="h-6 w-6" />
      </button>
      <div>
        <h1 className="text-2xl font-bold text-navy-700 dark:text-white">
          Resultados del Cuestionario
        </h1>
        <p className="text-gray-600">
          {questionnaireName} - {patientName}
        </p>
      </div>
    </div>
  );
};

export default ResultHeader; 